import { NgModule } from '@angular/core';

import { CmpsLazyRouterModule } from '../route.module';

import { LazyAdminRoutes } from './lazy.admin.route';

@NgModule({
    imports: [CmpsLazyRouterModule.forChild(LazyAdminRoutes)],
})
export class CmpsLazyAdminModule {}
